import React from 'react';
import { Navigate, Route, Routes } from 'react-router';
import { useTranslate } from '@im/react-localization';
import { NestedApiLocalizationProvider } from 'src/provider/LocalizationProviderConnector';
import { usePageTitle } from 'src/config';
import VendorDetail from './VendorDetail';
import SearchUI from './VendorSearchUI/SearchUI';
import AllUploadVendor from './AllVendorUploads';
import SearchResultScreen from './SearchResults/SearchResultsScreen';
import SimpleSearch from './SimpleSearch';
import EDListPage from './ExceptionDeals/EDListPage';
import EDDetailsPage from './ExceptionDeals/EDDetailsPage';
import AllDealsAndDiscounts from './allDealsAndDiscounts';
import VendorProgramDetail from './VendorProgramDetail';
import VendorProgramTemplate from './VendorProgramTemplate';
import { ProgramListProvider } from './util/ProgramListProvider';

export function VendorProgramRoute() {
  const translate = useTranslate();
  const { updatePageTitle } = usePageTitle();
  updatePageTitle(translate('VendorProgram.PageTitle'));
  return (
    <NestedApiLocalizationProvider
      preloadResources={[
        'VendorProgram',
        'VendorDeals',
        'ExceptionDeals',
        'Common',
        'Pagination',
      ]}
    >
      <ProgramListProvider>
        <Routes>
          <Route element={<Navigate replace to="program-list" />} path="" />
          <Route element={<SearchUI />} path="program-list" />
          <Route element={<VendorDetail />} path="vendor-detail" />
          <Route element={<VendorProgramDetail />} path="program-detail" />
          <Route element={<AllUploadVendor />} path="view-all-uploads" />
          <Route element={<SearchResultScreen />} path="search-results" />
          <Route element={<SimpleSearch />} path="details-page" />
          <Route element={<EDListPage />} path="exception-deal-list" />
          <Route element={<EDDetailsPage />} path="exception-deal-details" />
          <Route element={<VendorProgramTemplate />} path="program-template" />
          <Route
            element={<AllDealsAndDiscounts />}
            path="all-deals-and-discounts/*"
          />
        </Routes>
      </ProgramListProvider>
    </NestedApiLocalizationProvider>
  );
}
